<template>
  <div>
    <!-- FIXME - Standardize on headers outside of main screen -->
    <header>
      <h1>{{ header }}</h1>
      <span>{{ subheader }}</span>
    </header>

    <!-- FIXME - INCLUDE STATS ABOUT THE MONTH -->
    <!-- MOST COMMON BLOCK, LONGEST STREAK, BIGGEST CHANGE, ETC. -->

    <!-- FIXME - DO MUCH COOLER THINGS WITH THE DATA -->
    <template v-for="(category, key) in categories">
      <!-- FIXME - REFACTOR THIS - COMMON PARADIGM -->
      <div
        v-if="!category.parentId"
        :class="['flexRow categorySummary', category.children && category.showChildren ? 'hasChildren' : '']"
      >
        <category-details-block
          :category="category"
          :completed="getCategoryMonthSummary(key, !category.showChildren)"
          :quota="blocksPerDay(key, !category.showChildren)"
          :showQuota="false"
        />
        <!-- Include daily average -->

        <static-block-row
          class="staticBlockRow"
          :completed="getCategoryMonthSummary(key, !category.showChildren)"
          :quota="0"
          :color="category.color"
        />
      </div>
      <template v-if="category.showChildren">
        <div class="flexRow subcategory" v-for="childId in Object.keys(category.children || {})">
          <subcategory-details-block :categoryId="childId" />
          <static-block-row
            class="staticBlockRow"
            :completed="categories[childId].summaries.month"
            :quota="0"
            :color="getCategoryColor(childId)"
          />
        </div>
      </template>
    </template>

    <!-- Toggle between blocks and numbers/grid -->
    <!-- Toggle between calendar week and running week -->
    <!-- Toggle between blocks earned each day and cumulative -->
    <!-- By day vs by category -->

    <!-- TODO - Highlight current block -->
    <!-- TODO - Convert to blow-row with mouseover and interactions for each? This works for both category and weekday views -->
    <!--         <static-block-row
            class="weekProgress"
            :completed="daysCompleted"
            :quota="week.length"
            color="white"/>
 -->
    <!-- FIXME - Better positioning, please! -->

    <!--         <cumulative-week-view
            class="categorySummary"
            :categories="categories" />
 -->
  </div>
</template>

<script>
// TODO - Set default view for each user
// TODO - Support past weeks
import StaticBlockRow from "../components/StaticBlockRow.vue";
import CategoryDetailsBlock from "../components/CategoryDetailsBlock.vue";
import SubcategoryDetailsBlock from "../components/SubcategoryDetailsBlock.vue";

import db from "../db.js";
import util from "../util.js";
import categoryUtil from "../categoryUtil.js";

export default {
  name: "month-view",
  mixins: [categoryUtil.getMixin()],
  components: {
    "category-details-block": CategoryDetailsBlock,
    "subcategory-details-block": SubcategoryDetailsBlock,
    "static-block-row": StaticBlockRow,
  },
  props: ["categories"],
  created() {
    //FILL ME IN
  },
  methods: {
    blocksPerDay(id, includeChildren) {
      const numBlocks = categoryUtil.getThisMonthSummary(id, includeChildren);
      return Math.round((100 * numBlocks) / this.daysElapsed) / 100;
    },
  },
  computed: {
    header() {
      // FIXME - Deal with arbitrary months
      // let month = this.$route.params.month;
      // FIXME - Add formatting for other weeks
      // return month ? month : "IMPLEMENT ME";
      return util.getCurrentDayMoment().format("MMMM");
    },
    subheader() {
      // FIXME - Deal with arbitrary months
      return util.getCurrentDayMoment().format("YYYY");
    },
    daysElapsed() {
      return util.getCurrentDayMoment().format("D");
    },
  },
};
</script>

<style scoped>
header {
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eee;
}

.staticBlockRow.blockRow {
  max-width: calc(100% - 200px);
}
</style>



// WEBPACK FOOTER //
// MonthView.vue?0f857138